
import { User } from "@/types";
import { useNavigate } from "react-router-dom";
import AvatarPlaceholder from "@/components/ui/avatar-placeholder";

interface UserProfileCardProps {
  currentUser: User;
}

const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const formatDate = (): string => {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
};

const UserProfileCard = ({ currentUser }: UserProfileCardProps) => {
  const navigate = useNavigate();
  const firstName = currentUser.name?.split(" ")[0] || "Golfer";

  return (
    <div className="px-4 pt-6 pb-4 flex items-center justify-between">
      <div>
        <h1 className="font-display text-2xl font-semibold text-forest tracking-tight">
          {getGreeting()}, {firstName}
        </h1>
        <p className="text-sm text-muted-foreground mt-0.5">{formatDate()}</p>
      </div>
      <div onClick={() => navigate("/profile")} className="cursor-pointer">
        <AvatarPlaceholder
          user={currentUser}
          size="lg"
          className="border-2 border-gold/40 shadow-sm"
        />
      </div>
    </div>
  );
};

export default UserProfileCard;
